import React, { Suspense } from 'react';
import { Box, CircularProgress } from '@mui/material';
import Headbar from './Headbar';
import Footbar from './Footbar';
import { useLayoutContext } from '../../contexts/LayoutContext';

const ContentFallback = () => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '60vh',
      width: '100%',
    }}
  >
    <CircularProgress size={36} />
  </Box>
);

export default function AppShell({ children }) {
  const { headerProps, footerProps } = useLayoutContext();

  return (
    <>
      {headerProps && <Headbar {...headerProps} />}
      <Suspense fallback={<ContentFallback />}>
        {children}
      </Suspense>
      {footerProps && <Footbar {...footerProps} />}
    </>
  );
}
